import { render, staticRenderFns } from "./IconSvgCompass.vue?vue&type=template&id=49e356e6&scoped=true&"
import script from "./IconSvgCompass.vue?vue&type=script&lang=js&"
export * from "./IconSvgCompass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e356e6",
  null
  
)

export default component.exports